export default "__VITE_ASSET__761df1a3__"